import { render, staticRenderFns } from "./CreduDashboard.vue?vue&type=template&id=1cdd042f&scoped=true"
import script from "./CreduDashboard.vue?vue&type=script&lang=js"
export * from "./CreduDashboard.vue?vue&type=script&lang=js"
import style0 from "./CreduDashboard.vue?vue&type=style&index=0&id=1cdd042f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdd042f",
  null
  
)

export default component.exports